import React from 'react'

export default function Scope() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Scope</h4><br></br>
                    </div>

                    <div>
                    
                        <p>The plan is designed to build on the ongoing effort and dedication of the National IAS Steering Committee, external agencies and community to provide an effective and coordinated strategy for moving forward in the management of invasive species across Antigua and Barbuda. The plan provides a response to invasive species management with a focus on the roles and responsibilities of the National IAS Steering Committee.   It includes actions to be undertaken directly by various ministry staff in managing public land and in supporting residents and community groups to mitigate the impact of invasive species on private land.
                        </p>

                        <p>The NISSAP is one stage in the process of preventing the arrival and establishment of new invasive species and taking action to manage existing priority invasive species. It provides for the protection of people’s livelihoods and for the conservation of biodiversity. To maximize the benefits of available resources, the focus of the NISSAP is to manage invasive species threats to priority species and priority sites.  The NISSAP addresses threats to terrestrial, marine and freshwater ecosystems. The marine and freshwater components will be expanded as information becomes available.  The NISSAP is for the period 2020-2027, however the document is meant to be a working draft that will be continually updated as new information becomes available.
                        </p>

                        <p>The Plan ensures that the National IAS Steering Committee:
                        </p>
                    </div>

                    <div>
                        <ul>
                            <li>Aligns with national and state legislation and policy relating to invasive species. </li>
                            <li> Implements best practices in invasive species management on public and private lands. </li>
                            <li>Works strategically within the council and externally with community and other agencies.</li>
                            <li>Maximizes opportunities to engage and support private landholders to manage invasive species on their land.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}